export default "__VITE_ASSET__3td5fDPS__"